<div id="<%= dom_id recording %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Heat:</strong>
    <%= recording.heat_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Judge:</strong>
    <%= recording.judge_id %>
  </div>
</div>
